export default function tracker(
  method: "trackSingleCustom" | "trackCustom" | "track" | "trackSingle",
  event: string,
  data?: any,
  eventID?: string
) {
  const pixelIds = [
    process.env.NEXT_PUBLIC_FB_PIXEL_NEW_ID,
    process.env.NEXT_PUBLIC_FB_PIXEL_NEW_ID_2,
    process.env.NEXT_PUBLIC_FB_PIXEL_NEW_ID_3,
    process.env.NEXT_PUBLIC_FB_PIXEL_NEW_ID_4,
  ];
  const id = process.env.NEXT_PUBLIC_GTAG_NEW_ID;
  //@ts-ignore
  if (fbq) {
    pixelIds.forEach((pixelId) => {
      if (pixelId) {
        //@ts-ignore
        fbq(method, pixelId, event, data, { eventID });
      }
    });
  }
  if (event == "Lead") {
    //@ts-ignore
    if (gtag) {
      //@ts-ignore
      gtag("event", "generate_lead", { send_to: id });
    }
  } else {
    //@ts-ignore
    if (gtag) {
      //@ts-ignore
      gtag("event", event, { send_to: id });
    }
  }
}
